import { ChevronDown, ChevronRight } from 'react-feather';

const OrderDiscountsSection = ({
	sections,
	toggleSection,
	register,
}) => {
	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div
					className="title-block"
					onClick={(e) => toggleSection('notesTab', e)}
				>
					<h2 className="title-h2"> Discounts</h2>
					<button>
						{sections.notesTab ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.notesTab && (
					<>
						<div className="new-order-form">
							<div className="field-section-full">
								<div className="inp-col">
									<label htmlFor="totalDiscount">
										<strong>Discount</strong>
									</label>
									<input
										type="number"
										{...register('totalDiscount')}
										className="select-input"
										step="1.00"
									/>
								</div>
							</div>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default OrderDiscountsSection;
